import { Partner } from "dataTypes/partners";
import styles from "./styles.module.scss";
import { Link } from "react-router-dom";

export const AuthNavbarLogo: React.FC<{ partner?: Partner }> = ({ partner }) => {
  const logoUrl = partner?.logoMainUrl;
  const isValidLogo = !!logoUrl && logoUrl.trim() !== "";

  return isValidLogo ? (
    <a href={partner?.websiteUrl} className="flex">
      <img src={partner?.logoMainUrl} className={styles.navbarLogo} alt="company logo" />
    </a>
  ) : (
    <Link to="/">
      <div className="flueidpro-logo" />
    </Link>
  );
};

export const AuthFormLogo: React.FC<{ partner?: Partner }> = ({ partner }) => {
  if (!partner?.logoMainUrl) return null;
  return <img src={partner?.logoMainUrl} className={styles.formLogo} alt="company logo" />;
};
